var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.model && _vm.model.huangPuUniversity
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "page huangPuUniversity-page",
            attrs: { id: "print_huangPuUniversity" },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "font-size": "23px",
                  "text-align": "center",
                  "font-weight": "600",
                },
              },
              [
                _c(
                  "table",
                  {
                    staticStyle: {
                      width: "100%",
                      "border-collapse": "collapse",
                      border: "none",
                      "letter-spacing": "5px",
                    },
                  },
                  [
                    _c("tbody", [
                      _c(
                        "tr",
                        {
                          staticStyle: {
                            width: "100%",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c(
                            "td",
                            {
                              staticStyle: {
                                "border-collapse": "collapse",
                                border: "none",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.model.huangPuUniversity.reportName
                                    ? _vm.model.huangPuUniversity.reportName
                                    : "黄埔大学生检查报告"
                                )
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
            _c(
              "table",
              {
                staticStyle: {
                  "padding-left": "10px",
                  "text-align": "left",
                  width: "100%",
                  "margin-top": "10px",
                  "border-collapse": "collapse",
                  border: "none",
                },
              },
              [
                _c("tbody", [
                  _c(
                    "tr",
                    {
                      staticStyle: {
                        "line-height": "35px",
                        border: "none",
                        "margin-top": "10px",
                      },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "45%",
                            border: "none",
                            "margin-top": "10px",
                          },
                          attrs: { colspan: "7" },
                        },
                        [
                          _vm._v("学校："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.huangPuUniversity.schoolName
                                  ? _vm.model.huangPuUniversity.schoolName
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "30%",
                            border: "none",
                            "margin-top": "10px",
                          },
                          attrs: { colspan: "3" },
                        },
                        [
                          _vm._v("班级："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.huangPuUniversity.className
                                  ? _vm.model.huangPuUniversity.className
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _c(
              "table",
              {
                staticStyle: {
                  "text-align": "center",
                  width: "100%",
                  "border-collapse": "collapse",
                  border: "1px solid black",
                },
              },
              [
                _c("tbody", [
                  _c("tr", { staticStyle: { "line-height": "35px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("姓名")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.name
                                ? _vm.model.huangPuUniversity.name
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("性别")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.sex
                                ? _vm.model.huangPuUniversity.sex
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("年龄")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.age
                                ? _vm.model.huangPuUniversity.age
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "35px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("身份证号")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "6" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.idcard
                                ? _vm.model.huangPuUniversity.idcard
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "35px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "2" },
                      },
                      [_vm._v("一般检查")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("身高")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.height
                                ? _vm.model.huangPuUniversity.height
                                : ""
                            )
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-right": "15px",
                            },
                          },
                          [_vm._v("cm")]
                        ),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("体重")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.weight
                                ? _vm.model.huangPuUniversity.weight
                                : ""
                            )
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-right": "15px",
                            },
                          },
                          [_vm._v("kg")]
                        ),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "35px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("血压")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.systolicPressure
                                ? _vm.model.huangPuUniversity.systolicPressure
                                : ""
                            )
                          ),
                        ]),
                        _vm._v("/"),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.diastolicPressure
                                ? _vm.model.huangPuUniversity.diastolicPressure
                                : ""
                            )
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-right": "15px",
                            },
                          },
                          [_vm._v("mmhg")]
                        ),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("心率")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.pulseHeartRate
                                ? _vm.model.huangPuUniversity.pulseHeartRate
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "35px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "4" },
                      },
                      [_vm._v("内科")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("心肺")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.lung
                                ? _vm.model.huangPuUniversity.lung
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("神经系统")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.nervousSystem
                                ? _vm.model.huangPuUniversity.nervousSystem
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "35px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "2" },
                      },
                      [_vm._v("腹部器官")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "2", colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.abdomen
                                ? _vm.model.huangPuUniversity.abdomen
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("肝")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "3" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.liver
                                ? _vm.model.huangPuUniversity.liver
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "35px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("脾")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "3" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.spleen
                                ? _vm.model.huangPuUniversity.spleen
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "35px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("其他")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "5" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.internalOder
                                ? _vm.model.huangPuUniversity.internalOder
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "35px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "3" },
                      },
                      [_vm._v("外科")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("皮肤黏膜")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.skinMucousMembranes
                                ? _vm.model.huangPuUniversity
                                    .skinMucousMembranes
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("头颈")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.headNeck
                                ? _vm.model.huangPuUniversity.headNeck
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("淋巴结")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.lymphNode
                                ? _vm.model.huangPuUniversity.lymphNode
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "35px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("甲状腺")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.thyroidGland
                                ? _vm.model.huangPuUniversity.thyroidGland
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("脊柱")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.spine
                                ? _vm.model.huangPuUniversity.spine
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("四肢关节")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.limbsJoints
                                ? _vm.model.huangPuUniversity.limbsJoints
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "35px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("肛门生殖器")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.anogenitalRegion
                                ? _vm.model.huangPuUniversity.anogenitalRegion
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("疝")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.hernia
                                ? _vm.model.huangPuUniversity.hernia
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("其他")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.surgeryOder
                                ? _vm.model.huangPuUniversity.surgeryOder
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "35px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "80px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "3" },
                      },
                      [_vm._v("眼科")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("视力（裸眼）")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "80px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "2" },
                      },
                      [_vm._v("右")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.rightEyeVision
                                ? _vm.model.huangPuUniversity.rightEyeVision
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "80px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "2" },
                      },
                      [_vm._v("左")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.leftEyeVision
                                ? _vm.model.huangPuUniversity.leftEyeVision
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "35px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("视力（矫正）")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.correctRightEyeVision
                                ? _vm.model.huangPuUniversity
                                    .correctRightEyeVision
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.correctLeftEyeVision
                                ? _vm.model.huangPuUniversity
                                    .correctLeftEyeVision
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "35px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("色觉")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "120px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "4" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.colorVision
                                ? _vm.model.huangPuUniversity.colorVision
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "35px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "80px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "3" },
                      },
                      [_vm._v("耳鼻喉科")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("听力")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "80px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("右耳")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.rightEar
                                ? _vm.model.huangPuUniversity.rightEar
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "80px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("左耳")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.leftEar
                                ? _vm.model.huangPuUniversity.leftEar
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "35px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("鼻")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "120px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.nose
                                ? _vm.model.huangPuUniversity.nose
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("嗅觉")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "120px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.senseSmell
                                ? _vm.model.huangPuUniversity.senseSmell
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "35px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("咽喉")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "120px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "5" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.pharynx
                                ? _vm.model.huangPuUniversity.pharynx
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "35px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "80px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "3" },
                      },
                      [_vm._v("口腔科")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("面部")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "120px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "5" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.face
                                ? _vm.model.huangPuUniversity.face
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "35px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("口腔唇腭")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.cleftLipPalate
                                ? _vm.model.huangPuUniversity.cleftLipPalate
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("牙齿")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.teeth
                                ? _vm.model.huangPuUniversity.teeth
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "35px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("是否口吃")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.stuttering
                                ? _vm.model.huangPuUniversity.stuttering
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "120px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("发声是否嘶哑")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.hoarse
                                ? _vm.model.huangPuUniversity.hoarse
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "35px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("血常规")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "120px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "6" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.bloodRoutineTest
                                ? _vm.model.huangPuUniversity.bloodRoutineTest
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "35px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("肝功能")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "120px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "6" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.liverFunction
                                ? _vm.model.huangPuUniversity.liverFunction
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "35px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("DR胸部")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "120px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "6" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.dr
                                ? _vm.model.huangPuUniversity.dr
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "50px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "140px",
                          float: "left",
                          "margin-left": "5px",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("检查结果及结论：")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: { width: "100px", "text-align": "left" },
                        attrs: { colspan: "7" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.inspectionResults
                                ? _vm.model.huangPuUniversity.inspectionResults
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._m(0),
                  _c("tr", [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          float: "left",
                          "margin-left": "5px",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("医生签名：")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: { "text-align": "right" },
                        attrs: { colspan: "1" },
                      },
                      [
                        _vm.model.huangPuUniversity.doctorSignature
                          ? _c("img", {
                              staticStyle: {
                                height: "40px",
                                width: "100px",
                                "object-fit": "contain",
                              },
                              attrs: {
                                src: _vm.model.huangPuUniversity
                                  .doctorSignature,
                              },
                            })
                          : _vm._e(),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "text-align": "right",
                          "padding-right": "35px",
                          "letter-spacing": "2.5px",
                        },
                        attrs: { colspan: "5" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.huangPuUniversity.physicalDate
                                ? _vm.dayform(
                                    _vm.model.huangPuUniversity.physicalDate
                                  )
                                : "年  月  日"
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ]
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", { staticStyle: { "text-align": "right" } }, [
      _c(
        "td",
        {
          staticStyle: { "padding-right": "35px", "padding-top": "30px" },
          attrs: { colspan: "7" },
        },
        [_vm._v("（体检机构盖章）")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }